import { formatDateFromString } from "../../Utils/externalFunctions";

const DateSortFunction =
  (columnString, type = "default") =>
  (rowA, rowB) => {
    let a = rowA[columnString];
    let b = rowB[columnString];

    if (type == "string") {
      a = new Date(formatDateFromString(rowA[columnString]));
      b = new Date(formatDateFromString(rowB[columnString]));
    }

    return a > b ? 1 : b > a ? -1 : 0;
  };

export default DateSortFunction;
